<template functional>
  <div class="appt-lfd flex-col" :class="props.item.appt_lfd">
    <div>{{ props.item.lfd_fmt }}</div>
    <div class="text-2xs" v-if="props.item.rail_lfd_time">
      {{ props.item.rail_lfd_time }}
    </div>
  </div>
</template>

<script>
export default {
  name: "drayage-lfd",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
